<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <a-col :span="6">
          <a-form-item v-has="'buffer2'" :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['buffer2' ,{'initialValue': '1'}]" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </j-form-container>
</template>
<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'

export default {
  name: 'SubsidyListForm',
  components: {
    JFormContainer,
  },
  props:{
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      validatorRules: {
      },
      confirmLoading: false,
    }
  },
  methods:{
    initFormData(url,id){
      this.clearFormData()
      if(!id){
        this.edit({})
      }else{
        getAction(url,{id:id}).then(res=>{
          if(res.success){
            let records = res.result
            if(records && records.length>0){
              this.edit(records[0])
            }
          }
        })
      }
    },
    edit(record){
      this.model = Object.assign({}, record)
      console.log("SubsidyListForm-edit",this.model);
      let fieldval = pick(this.model,'buffer2')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
    },
    getFormData(){
      let formdata_arr = []
      this.form.validateFields((err, values) => {
        if (!err) {
          let formdata = Object.assign(this.model, values)
          let isNullObj = true
          Object.keys(formdata).forEach(key=>{
            if(formdata[key]){
              isNullObj = false
            }
          })
          if(!isNullObj){
            formdata_arr.push(formdata)
          }
        }else{
          this.$emit("validateError","合同明细表单校验未通过");
        }
      })
      console.log("合同明细表单数据集",formdata_arr);
      return formdata_arr;
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'buffer2'))
    },
    clearFormData(){
      this.form.resetFields()
      this.model={}
    },
  }
}
</script>
